import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";

import { TranslateService } from "@ngx-translate/core";

import { ConfigStateService } from "@abp/ng.core";
import { AbpOAuthService } from "@abp/ng.oauth";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomService } from "@proxy/custom.service";
import { Roles } from "src/app/core/model/role_contstant";
import { NIPRApiService } from "src/app/core/services/niprapi.service";
import { ProfileService } from "src/app/core/services/profile.service";
import { TourShareService } from "src/app/shared/common-tour/tour-share-service";
import { SignalRService } from "src/app/shared/signalR/signalr.service";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
})
export class TopbarComponent implements OnInit {
  userInfo: any;

  messages: any;
  element: any;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  allnotifications: any;
  flagvalue: any;
  valueset: any;
  cookieValue: any;
  total = 0;
  cart_length: any = 0;
  totalNotify: number = 0;
  newNotify: number = 0;
  readNotify: number = 0;
  isDropdownOpen = false;
  @ViewChild("removenotification") removenotification!: TemplateRef<any>;
  notifyId: any;
  showNotificationIcon: any;
  notificationList: any;
  notificationCount: any;
  environmentURL = environment;
  currentUser: any;
  imageSrc: any;
  currentUserDetails: any;
  isPopup = false;
  isPopoverOpen: any;
  isDropdown = false;

  constructor(
    private readonly modalService: NgbModal,
    public translate: TranslateService,
    private readonly router: Router,
    public abpOauthService: AbpOAuthService,
    private readonly config: ConfigStateService,
    private readonly profileService: ProfileService,
    private readonly sanitizer: DomSanitizer,
    private readonly _route: ActivatedRoute,
    public service: NIPRApiService,
    private readonly signalRService: SignalRService,
    private readonly customService: CustomService,
    private readonly el: ElementRef,
    private readonly tourShareService: TourShareService
  ) { }

  ngOnInit(): void {
    this.customService.getMyProfile().subscribe((res: any) => {
      this.currentUserDetails = res;
    });
    this.currentUser = this.config.getOne("currentUser");
    if (this.abpOauthService.isAuthenticated) {
      this.profileService
        .getProfileImage(this.currentUser.id)
        .subscribe((res: any) => {
          this.imageSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
            `data:image/jpg;base64, ${res.fileContent}`
          );
        });
    }
    if (this.currentUser.roles.includes(Roles.Admin)) {
      this.showNotificationIcon = false;
    } else {
      this.showNotificationIcon = true;
      this.getNotification();
      this.registerMessageHandler();
      this.registerNewMessageHandler();
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isPopoverOpen?.hide()
      this.isPopup = false;
    }
  }

  getNotification() {
    const currentUser = this.config.getOne("currentUser");
    if (!currentUser.roles.includes(Roles.Admin)) {
      this.profileService.getTopNotification().subscribe((res) => {
        if (res) {
          this.notificationList = res[0].notifications;
          this.notificationCount = res[0].unreadNotification;
        }
      });
    }
  }
  private registerMessageHandler(): void {
    this.signalRService.getNotifications().subscribe((notification: any) => {
      this.notificationCount = notification.unreadNotification;
      this.notificationList = notification.notifications;
    });
  }
  private registerNewMessageHandler(): void {
    this.signalRService.getNewNotifications().subscribe((notification: any) => {
      this.notificationCount = notification.unreadNotification;
      this.notificationList = notification.notifications;
    });
  }
  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    document.querySelector(".hamburger-icon")?.classList.toggle("open");
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Open modal
   * @param content modal content
   */
  openModal(content: any) {
    this.modalService.open(content, { centered: true });
  }

  navigate() {
    this.router.navigate(["/" + localStorage.getItem("route") + "/setting"]);
  }

  /**
   * Logout the user
   */
  logout() {
     const iframe = document.getElementById('logout-broker') as HTMLIFrameElement;
iframe?.contentWindow?.postMessage("logout", "*");
setTimeout(() => {  
   this.abpOauthService.logout();
}, 2000); // 2000 milliseconds (2 seconds) delay
  }
  
  windowScroll() {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      (document.getElementById("back-to-top")).style.display =
        "block";
      document.getElementById("page-topbar")?.classList.add("topbar-shadow");
    } else {
      (document.getElementById("back-to-top")).style.display =
        "none";
      document.getElementById("page-topbar")?.classList.remove("topbar-shadow");
    }
  }

  // Delete Item
  deleteItem(event: any, id: any) {
    let price = event.target
      .closest(".dropdown-item")
      .querySelector(".item_price").innerHTML;
    let Total_price = this.total - price;
    this.total = Total_price;
    this.cart_length = this.cart_length - 1;
    const emptyCart = document.getElementById("empty-cart");
    if (emptyCart) {
      emptyCart.style.display = this.total > 1 ? "none" : "block";
    }
    document.getElementById("item_" + id)?.remove();
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    if (this.isDropdownOpen) {
      this.isDropdownOpen = false;
    } else {
      this.isDropdownOpen = true;
    }
  }

  // Remove Notification
  checkedValGet: any[] = [];
  onCheckboxChange(event: any, id: any): void {
    this.notifyId = id;

    const collectionToProcess = id === "1" ? this.allnotifications : this.messages;
    const checkedVal: any[] = [];

    for (const item of collectionToProcess) {
      if (item.state) {
        checkedVal.push(item.id);
      }
    }
    this.checkedValGet = checkedVal;
    this.updateNotificationActionsVisibility(checkedVal.length > 0);
  }

  private updateNotificationActionsVisibility(shouldShow: boolean): void {
    const actionElement = document.getElementById("notification-actions");
    if (actionElement) {
      actionElement.style.display = shouldShow ? "block" : "none";
    }
  }

  notificationDelete() {
    const checkedIds = new Set(this.checkedValGet);
    if (this.notifyId === "1") {
      this.allnotifications = this.allnotifications.filter(
        notification => !checkedIds.has(notification.id)
      );
    } else {
      this.messages = this.messages.filter(
        message => !checkedIds.has(message.id)
      );
    }

    this.calculatenotification();
    this.modalService.dismissAll();
  }


  calculatenotification() {
    this.totalNotify = 0;
    this.checkedValGet = [];

    const notificationActions = document.getElementById("notification-actions");
    if (notificationActions) {
      notificationActions.style.display = this.checkedValGet.length > 0 ? "block" : "none";
    }
    if (this.totalNotify == 0) {
      document
        .querySelector(".empty-notification-elem")
        ?.classList.remove("d-none");
    }
  }

  async login() {
    this.abpOauthService.init();

    if (this._route.snapshot.params.type == "undefined") {
      this.router.navigate(["nextere"]);
    } else {
      localStorage.setItem("route", this._route.snapshot.params.type);
    }
    this.currentUser = this.config.getOne("currentUser");
    if (this.abpOauthService.isAuthenticated) {
      this.signalRService.initializeConnection(
        this.abpOauthService.getAccessToken()
      );
    }
    if (!this.abpOauthService.isAuthenticated) {
      localStorage.setItem("route", this._route.snapshot.params.type);
      this.abpOauthService.navigateToLogin({
        Code: this._route.snapshot.params.type,
        __tenant: "DES_A",
      });
    } else {
      this.checkUrlRedirect();
    }
  }

  checkUrlRedirect() {
    if (
      !this._route.snapshot.url
        .join("/")
        .includes(localStorage.getItem("route"))
    ) {
      this.router.navigate([
        localStorage.getItem("route") +
        "/" +
        this._route.snapshot.url.join("/"),
      ]);
    }
  }

  dropdownClick() {
    this.isDropdown = !this.isDropdown
  }

  checkOpen(anchor) {
    this.isPopoverOpen = anchor;
    this.isPopup = !this.isPopup;
    anchor.toggle()
  }
  tour() {
    this.tourShareService.notifyClearCookie();
  }
  allNotifications() {
    this.router.navigate(['/' + localStorage.getItem('route') + '/notification']);
  }
}
